import { setCookie } from '@djs/cookie';

const INITIAL_FRAGMENT_COOKIE_NAME = 'pwa_initial_fragment';

/**
 * Устанавливаем no-http-only cookie, они при добавлении иконки на рабочий стол "прокопируются" в PWA браузер
 * и будут жить там "своей жизнью". Это позволяет передать в PWA диплинк "на первый запуск", и потом его подчистить внутри PWA
 * Трюк «Copy-on-install» (https://habr.com/ru/articles/989862/ и https://progressier.com/pwa-capabilities/cookies-demo)
 */
export const saveHash = () => {
  setCookie(INITIAL_FRAGMENT_COOKIE_NAME, window.location.hash);
};
